















































































import {
  defineComponent,
  PropType,
  ref,
  useFetch,
} from "@nuxtjs/composition-api";
import FreeGiftCart from "~/modules/checkout/components/cartSidebar/freeGift/FreeGiftCart.vue";
import { useSearchProducts } from "~/composables";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";

export default defineComponent({
  name: "FreeGiftListModal",
  components: { FreeGiftCart, SkeletonLoader },
  props: {
    needMoney: {
      type: Number,
      default: 0,
    },
    skus: {
      type: String,
      default: "",
    },
    needQty: {
      type: Number,
      default: 0,
    },
    ampromoRuleId: {
      type: String as PropType<string| number>,
      default: null,
    },
  },

  setup(props, { emit }) {
    const { fetchProducts, loading } = useSearchProducts();

    const productsFreeGift = ref([]);
    useFetch(async () => {
      try {
        let skuArr = props.skus.split(",");
        const params = {
        skus: skuArr,
        pageSize: 10,
      };
      const { data } = await fetchProducts(params);
        const products = data ?? [];
        if (products && products?.length) {
          const filteredProducts = products?.map((item) => {
            if (item.configurable_children && Array.isArray(item.configurable_children)) {
              item.configurable_children = item.configurable_children.filter(
                (variant) =>
                  variant.sku &&
                  skuArr.includes(variant.sku)
              );
            }
            return item;
          });

          productsFreeGift.value = filteredProducts;
        } else {
          productsFreeGift.value = [];
        }
      } catch (e) {
        console.log("error: ", e);
      }
    });
    const closeModal = () => {
      emit("close");
    };
    return {
      closeModal,
      productsFreeGift,
      loading,
    };
  },
});
